import { Link } from "react-router-dom";

const affiliateUrl = "https://hb.afl.rakuten.co.jp/hsc/57e07128.1f812976.57e07129.192400c1/?link_type=hybrid_url&rafst=rmn&ut=eyJwYWdlIjoic2hvcCIsInR5cGUiOiJoeWJyaWRfdXJsIiwiY29sIjoxLCJjYXQiOjEsImJhbiI6MjM3Nzg5MiwiYW1wIjpmYWxzZX0%3D";
const productUrl = "https://network.mobile.rakuten.co.jp/product/iphone/iphone-18-pro/";
const campaignUrl = "https://network.mobile.rakuten.co.jp/campaign/iphone-upgrade/";

function Table({ caption, headers, rows }: { caption: string; headers: string[]; rows: string[][] }) {
  return <div className="not-prose my-7 overflow-x-auto border-y-2 border-foreground-900 bg-white">
    <table className="w-full min-w-[620px] border-collapse text-left text-sm">
      <caption className="p-3 text-left font-bold">{caption}</caption>
      <thead className="bg-background-100"><tr>{headers.map(h => <th key={h} scope="col" className="p-3">{h}</th>)}</tr></thead>
      <tbody>{rows.map(row => <tr key={row[0]} className="border-t border-background-300">{row.map((cell, i) => i === 0 ? <th key={i} scope="row" className="p-3 font-bold">{cell}</th> : <td key={i} className="p-3 leading-6">{cell}</td>)}</tr>)}</tbody>
    </table>
  </div>;
}

export default function RakutenIphone18ProArticle() {
  return <>
    <section id="monthly">
      <h2>毎月いくら払う？</h2>
      <Table caption="端末代とRakuten最強プランの通信料（税込・割引前）" headers={["毎月のデータ使用量", "端末代", "通信料", "毎月の合計"]} rows={[
        ["3GBまで", "5,331円", "1,078円", "6,409円"],
        ["3GB超〜20GBまで", "5,331円", "2,178円", "7,509円"],
        ["20GB超", "5,331円", "3,278円", "8,609円"],
      ]} />
      <p>通信料はその月に使ったデータ量で自動的に決まり、プラン変更の手続きは不要です。表にはRakuten Linkを使わずに発信した通話料や保証オプション料は含みません。</p>
      <p>端末代5,331円は1〜47回目の金額です。48回目は5,343円。最新価格は<a href={productUrl} target="_blank" rel="noreferrer">iPhone 18 Proの商品ページ</a>、通信料は<a href="https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/" target="_blank" rel="noreferrer">Rakuten最強プランの料金ページ</a>で確認できます。</p>
    </section>

    <section id="device-total">
      <h2>2年で返すなら127,944円。返さないなら255,900円</h2>
      <p>買い替え超トクプログラムでは、返す場合も払い終える場合も、1〜24回目の端末代は月5,331円です。違うのは、その後の支払いと端末の扱いです。</p>
      <Table caption="iPhone 18 Pro 256GBを返す場合・返さない場合" headers={["使い方", "支払回数", "端末代の合計", "別途かかる費用"]} rows={[
        ["25カ月目に返却", "24回", "127,944円", "返却事務手数料3,300円"],
        ["返却せずに使い続ける", "48回", "255,900円", "なし"],
      ]} />
      <p><strong>約2年で返す場合：</strong>25カ月目以降に端末を返却し、楽天モバイルの条件を満たすと残りの支払いが不要になります。返却できるのは25〜47カ月目です。新しいスマホに機種変更せず、返却だけすることもできます。</p>
      <p><strong>返さない場合：</strong>48回まで端末代を支払います。1〜47回目は月5,331円、48回目は5,343円で、合計255,900円です。払い終えたiPhoneはそのまま使い続けられます。</p>
      <p>一括払い・24回払いも選べますが、この記事の毎月の金額と返却時の計算は買い替え超トクプログラムを選んだ場合です。詳しくは<a href="https://network.mobile.rakuten.co.jp/guide/replacement-program/" target="_blank" rel="noreferrer">プログラムの公式案内</a>をご覧ください。</p>
    </section>

    <section id="benefits">
      <h2>端末を買うだけでなく、回線も楽天にする理由</h2>
      <h3>データをたくさん使っても通信料は月3,278円</h3>
      <p>データ使い放題の料金を、各社の割引前の月額で比べました。</p>
      <Table caption="大容量プランの割引前月額（税込）" headers={["会社・プラン", "月額", "データ量・速度の注意点"]} rows={[
        ["楽天モバイル Rakuten最強プラン", "3,278円", "混雑時などに速度制御の場合あり"],
        ["au 使い放題MAX＋", "7,788円", "月200GB超で最大5Mbps。テザリングは月60GBまで"],
        ["ソフトバンク テイガク無制限", "8,008円", "直近30日で300GB超の場合は最大4.5Mbps"],
        ["ドコモ MAX", "8,448円", "大量の通信時などに速度制限の場合あり"],
      ]} />
      <p>割引前では楽天モバイルが他社より月4,500円ほど低い金額です。各社の家族割・光回線セット割や付帯サービスは異なります。実際の節約額は、今の請求明細と比べて判断してください。</p>
      <p>比較元：<a href="https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/" target="_blank" rel="noreferrer">楽天モバイル</a>／<a href="https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/" target="_blank" rel="noreferrer">au</a>／<a href="https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/" target="_blank" rel="noreferrer">ソフトバンク</a>／<a href="https://www.docomo.ne.jp/charge/docomo_max/" target="_blank" rel="noreferrer">ドコモ</a></p>
      <h3>Rakuten Linkからの対象国内通話は追加月額なし</h3>
      <p>楽天モバイルなら、Rakuten Linkアプリから対象の番号へ発信した国内通話は、追加の月額料金なしで利用できます。ドコモ・au・ソフトバンクの国内通話かけ放題オプションは、各社月1,980円です。</p>
      <ul><li>iPhone標準の電話アプリから国内に発信すると、30秒ごとに22円かかります。</li><li>0570から始まる番号や188など、一部の番号は無料通話の対象外です。</li><li>Rakuten Linkを使っていない相手からの電話は、iPhone標準の電話アプリに着信します。</li></ul>
      <p>Rakuten Linkアプリにはデータ使用量や契約内容を確認する「my 楽天モバイル」の機能もあります。詳しい対象条件は<a href="https://network.mobile.rakuten.co.jp/service/rakuten-link/" target="_blank" rel="noreferrer">Rakuten Linkの公式案内</a>で確認してください。</p>
      <h3>購入特典は20,000ポイント。残りは紹介特典</h3>
      <p>iPhone 18 Proを購入し、キャンペーン条件を満たすと20,000ポイントを受け取れます。「最大40,000ポイント」の残り最大20,000ポイントは、ほかの人を楽天モバイルに紹介して条件を満たした場合の特典です。</p>
      <p>ポイントは5カ月に分けて付与され、付与日から6カ月間有効です。端末代から購入時に差し引かれるものではありません。乗り換えと既存利用者の機種変更では条件が違うため、<a href={campaignUrl} target="_blank" rel="noreferrer">公式キャンペーンページ</a>で確認してください。</p>
      <h3>回線契約の事務手数料は原則無料</h3>
      <p>楽天モバイルの通常の回線契約事務手数料は、同一名義の累計4回線目まで無料です。これは端末を返すときの事務手数料3,300円とは別です。</p>
    </section>

    <section id="cautions">
      <h2>買う前に確認したいこと</h2>
      <h3>電波は、実際に使う場所で確認する</h3>
      <p>電波の入り方や速度は場所によって変わります。地下や建物の中などでは速度が落ちることもあります。申し込む前に<a href="https://network.mobile.rakuten.co.jp/area/" target="_blank" rel="noreferrer">公式エリアマップ</a>で、自宅・職場・通勤経路を確認してください。</p>
      <h3>48回払いには本人名義の楽天カードが必要</h3>
      <p>買い替え超トクプログラムで支払いに使えるのは、プログラム契約者本人名義の楽天カードです。たとえば夫がプログラムを契約し、妻名義の楽天カードで支払う組み合わせは使えません。家族カードを予定している場合は、申込み前に楽天モバイルへ確認してください。</p>
      <h3>返却時には端末の状態が確認される</h3>
      <p>返却時には事務手数料3,300円がかかります。iPhoneが「損傷品」と判定された場合の故障費用は22,000円です。返却を受け付けられない状態なら、残りの端末代の支払いが必要です。機種変更に伴って古い端末を返す場合は、新端末の受け取りから20日以内に返送します。</p>
      <p>返却を考えている人は<a href="https://network.mobile.rakuten.co.jp/guide/replacement-program/loss/" target="_blank" rel="noreferrer">状態基準と費用</a>を購入前に確認してください。</p>
    </section>

    <section id="campaign-conditions">
      <h2>20,000ポイントは、乗り換えと機種変更で条件が違う</h2>
      <p className="text-sm text-foreground-600">2026年10月5日に公式キャンペーンを再確認。2026年9月12日開始・終了日未定です。</p>
      <Table caption="20,000ポイントの主な条件" headers={["", "他社から乗り換える人", "楽天モバイル利用中の人"]} rows={[
        ["事前エントリー", "プラン申込みより前に必要", "端末購入より前に必要"],
        ["同じ月の手続き", "対象プラン申込みとiPhone 18 Pro購入", "iPhone 18 Pro購入"],
        ["追加条件", "期限までに利用開始、Rakuten Linkから10秒以上通話", "購入月の前月末までに対象プランの利用開始"],
      ]} />
      <p>これは主な条件です。対象外条件や期限、適用回数を含めて<a href={campaignUrl} target="_blank" rel="noreferrer">キャンペーンの公式条件</a>を確認してください。</p>
    </section>

    <section id="apply">
      <h2>自分の使い方に合いそうなら、条件を確認して次へ</h2>
      <p>データを毎月20GB以上使い、国内通話も多い人なら、楽天モバイルの料金は魅力的です。エリアマップで自宅と職場を確認し、月々の支払いが予算に合えば、申込み条件を見てみてください。</p>
      <h3>他社から乗り換える人</h3>
      <ol><li>エリアと本人名義の楽天カードを確認する。</li><li>キャンペーン条件を確認し、申込み前にエントリーする。</li><li>エントリーと同じ月にプラン申込みとiPhone 18 Proの購入をする。</li><li>開通後、指定の期限までにRakuten Linkから10秒以上通話する。</li></ol>
      <div className="not-prose my-7 grid gap-3 sm:grid-cols-2">
        <a href={campaignUrl} target="_blank" rel="noreferrer" className="rounded-lg border border-[#bf006b] px-5 py-4 text-center font-bold text-[#bf006b] hover:bg-[#fff2f8]">キャンペーン条件を確認・エントリー ↗</a>
        <a href={affiliateUrl} target="_blank" rel="nofollow sponsored noopener noreferrer" className="rounded-lg bg-[#bf006b] px-5 py-4 text-center font-bold text-white hover:bg-[#9a0057]">楽天モバイルの料金・申込みを確認する［PR］ ↗</a>
      </div>
      <p>iPhone 18 Proの容量や在庫は<a href={productUrl} target="_blank" rel="noreferrer">公式商品ページ</a>で確認できます。</p>
      <h3>すでに楽天モバイルを使っている人</h3>
      <ol><li>Rakuten Linkアプリ内の「my 楽天モバイル」で今の端末の支払い残額と利用月数を確認する。今の端末も買い替え超トクプログラムで購入した場合、返却して残りの支払いが不要になるのは25カ月目から。</li><li>キャンペーンの条件を確認し、端末購入前にエントリーする。</li><li>エントリーと同じ月にiPhone 18 Proを購入する。</li></ol>
      <p><a href={campaignUrl} target="_blank" rel="noreferrer">機種変更のキャンペーンを確認する ↗</a> ／ <a href={productUrl} target="_blank" rel="noreferrer">iPhone 18 Proの価格・在庫を見る ↗</a></p>
      <p>カラーによっては届くまで時間がかかる場合があります。購入画面で最新の価格と在庫を確認してください。</p>
      <p><Link to="/articles/rakuten-guide">楽天モバイルの料金・電波・通話を詳しく見る →</Link></p>
    </section>
  </>;
}
